import SEO from "../components/SEO";
import { useTheme } from "../context/ThemeContext";
import { Reveal } from "../components/motion/Reveal";

const ARTISAN = "https://images.unsplash.com/photo-1681407979977-ea6060c802f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxhcnRpc2FuJTIwd29ya2luZyUyMG9uJTIwbWV0YWx8ZW58MHx8fHwxNzg1OTY5MjAzfDA&ixlib=rb-4.1.0&q=85";
const TEXTURE = "https://images.unsplash.com/photo-1545873509-33e944ca7655?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxjbG9zZSUyMHVwJTIwb2YlMjBnb2xkZW4lMjBtZXRhbCUyMHRleHR1cmV8ZW58MHx8fHwxNzg1OTY5MjA0fDA&ixlib=rb-4.1.0&q=85";

export default function About() {
  const { content, seo } = useTheme();
  return (
    <div data-testid="about-page">
      <SEO title={seo.about_title || "Our Story"} description={seo.about_description || "Humaira Crafts — manufacturing premium metal home décor in Delhi since 2002. Learn about our heritage and craftsmanship."} />
      <section className="max-w-7xl mx-auto px-4 md:px-8 py-24">
        <Reveal>
          <p className="small-caps text-gold mb-4" data-eid="about-kicker" data-etype="text">{content.about_hero_kicker}</p>
          <h1 className="text-4xl md:text-6xl tracking-tighter font-semibold max-w-3xl leading-none" data-eid="about-title" data-etype="text">{content.about_hero_title}</h1>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-4 md:px-8 grid md:grid-cols-2 gap-16 items-center pb-24">
        <Reveal y={40}>
          <img src={ARTISAN} alt="Artisan handcrafting metal décor at Humaira Crafts, Delhi" className="w-full aspect-[4/3] object-cover border border-black/10" data-eid="about-image" data-etype="image" />
        </Reveal>
        <Reveal delay={0.15}>
          <p className="small-caps text-gold mb-4"><span className="opacity-60 mr-2">N° 01 ·</span>Our Story</p>
          <h2 className="text-3xl tracking-tight font-semibold mb-6" data-eid="about-s1-heading" data-etype="text">{content.about_s1_heading}</h2>
          <p className="text-muted-foreground leading-relaxed text-sm md:text-base" data-eid="about-s1-p1" data-etype="text">{content.about_s1_p1}</p>
          <p className="text-muted-foreground leading-relaxed text-sm md:text-base mt-4" data-eid="about-s1-p2" data-etype="text">{content.about_s1_p2}</p>
        </Reveal>
      </section>

      <section className="bg-[#111111] text-[#FAF9F6] py-24">
        <div className="max-w-7xl mx-auto px-4 md:px-8 grid md:grid-cols-2 gap-16 items-center">
          <Reveal>
            <p className="small-caps text-gold mb-4"><span className="opacity-60 mr-2">N° 02 ·</span>{content.about_s2_kicker}</p>
            <h2 className="text-3xl tracking-tight font-semibold mb-6 text-[#FAF9F6]" data-eid="about-s2-heading" data-etype="text">{content.about_s2_heading}</h2>
            <ul className="text-[#A3A3A3] text-sm md:text-base leading-loose columns-2">
              {content.about_s2_items.split("\n").filter(Boolean).map((item) => <li key={item}>{item}</li>)}
            </ul>
          </Reveal>
          <Reveal delay={0.15} y={40}>
            <img src={TEXTURE} alt="Close-up of hand-finished golden metal texture" className="w-full aspect-[4/3] object-cover" data-eid="about-texture-image" data-etype="image" />
          </Reveal>
        </div>
      </section>
    </div>
  );
}
